import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

type HeaderProps = {
    size?: 'small' | 'medium' | 'large' | 'xLarge' | 'xxLarge';
    dataTn?: string;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    htmlElementType?: 'div' | 'h1' | 'h2';
};

export const Header: FunctionComponent<HeaderProps> = props => {
    const { size = 'large', title, subtitle, dataTn, htmlElementType = 'div' } = props;

    const TitleTag = htmlElementType;

    return (
        <React.Fragment>
            <TitleTag
                data-tn={`header-title${dataTn ? `-${dataTn}` : ''}`}
                className={classnames(styles.title, styles[size])}
            >
                {title}
            </TitleTag>
            {subtitle && (
                <div
                    data-tn={`header-subtitle${dataTn ? `-${dataTn}` : ''}`}
                    className={classnames(styles.subtitle, styles[size])}
                >
                    {subtitle}
                </div>
            )}
        </React.Fragment>
    );
};
